module.exports = ".fa.fa-spinner{font-size:30px;margin-right:5px;display:inline-block;vertical-align:top}"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-time/personal-daily-report/personal-daily-report.component.scss
// module id = 505
// module chunks = 0